export class SubscriberForgottenModel {
    id: number|undefined = undefined
    name: string = ""
    realName: string = ""
    idExternal: string = ""
    alias: string = ""
    createdAt: Date|string = ""
    days: number = 0

    constructor(s?:Partial<SubscriberForgottenModel>) {
        Object.assign(this, s)
    }
}
